var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "rearing",
            "title": "Solution",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" Vertical farm facility ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    staticClass: "mb-0",
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v("Based on root zone measurement and control technology as the basics of crop cultivation, "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("the system enables precise agriculture for optimal produce by supplying the most suitable nutrient solutions to the crops.")];
      },
      proxy: true
    }])
  }, [_c('b', [_vm._v("The hydroponic management system")]), _vm._v(" "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("that enables the cultivation "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("of higher-quality agricultural products ")])], 1), _c('page-section', {
    staticClass: "page-section--last grey lighten-5"
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "570",
            "aspect-ratio": 570 / 456,
            "src": "/images/sub/solution/plant/rearing-img.jpg"
          }
        })], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', {
          staticClass: "mt-md-24px"
        }, [_c('tit-wrap-sprout', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Real-time monitoring of the growth environment of greenhouse crops ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Vertical Farm Cultivation Shelf System ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Composition")];
            },
            proxy: true
          }])
        }, [_vm._v(" Supply detection unit, drainage detection unit, weight detection unit, nutrient solution supply unit, display unit, control unit, and warning unit ")]), _c('div', {
          staticClass: "mt-16px mt-md-24px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "570",
            "aspect-ratio": 570 / 158,
            "src": "/images/sub/solution/plant/rearing-img2-en.png"
          }
        })], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": "",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "696",
            "aspect-ratio": 696 / 474,
            "src": "/images/sub/solution/plant/rearing-img3.jpg"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v("Once you enter threshold values in the cultivation system, its warning unit issues a warning whenever any of the preset threshold values is exceeded; thus realizing the most efficient cultivation.")];
            },
            proxy: true
          }])
        })], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/plant/rearing-img4.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Apparatus for Managing Nutriculture ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered Patent ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }